import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import ErasTourPrivacyPolicy from './pages/ErasTourPrivacyPolicy';
import ErasTourTermsOfUse from './pages/ErasTourTermsOfUse';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/erastour-privacypolicy" element={<ErasTourPrivacyPolicy />} />
        <Route path="/erastour-termsofuse" element={<ErasTourTermsOfUse />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
